import React from "react";
import CountUp from "react-countup";
import "./css/styles.css";
import customers from "./../home/imgs/numbers/customerss.png";
import done from "./../home/imgs/numbers/done.png";
import partners from "./../home/imgs/numbers/partners.png";

export function Numbers() {
  return (
    <div className="max-w-screen-xl mx-auto grid gap-4 p-8 bg-customBlueheader shadow-2xl shadow-customBlue rounded-lg md:grid-cols-2">
      <div>
        <h2 className="text-white text-center font-semibold text-4xl p-8">
          Our Achievements
        </h2>

        <div className="md:flex space-y-4 space-x-2 text-white">
          {/* Trusted Customers */}
          <div className="space-y-6 group flex flex-col items-center">
            <div className="bg-white">
              <img
                src={customers}
                alt="Customer who have satisfied by Grandshop Rwanda"
                className="images w-48 h-32 object-contain"
              />
            </div>
            <div className="countupf flex flex-cols-2 space-x-4">
              <CountUp
                end={300}
                duration={10}
                className="text-5xl font-bold group-hover:scale-110 transition-transform"
              />
              <div className="font-extrabold  text-white text-3xl">+</div>
            </div>
            <p className="pt-6 text-lg group-hover:text-blue-300 transition-colors">
              Trusted Customers
            </p>
          </div>

          {/* Completed Projects */}
          <div className="space-y-6 group flex flex-col items-center">
            <div className="bg-white">
              <img
                src={done}
                alt="Customer who have satisfied by Grandshop Rwanda"
                className="images w-48 h-32 object-contain"
              />
            </div>
            <div className="countupf flex flex-cols-2 space-x-4">
              <CountUp
                end={340}
                duration={10}
                className="text-5xl font-bold group-hover:scale-110 transition-transform"
              />
              <div className="font-extrabold  text-white text-3xl">+</div>
            </div>
            <p className="mt-2 py-2 text-lg group-hover:text-blue-300 transition-colors">
              Completed Projects
            </p>
          </div>

          {/* Trusted Partners */}
          <div className="space-y-6 group flex flex-col items-center">
            <div className="bg-white !border-none">
              <img
                src={partners}
                alt="Customer who have satisfied by Grandshop Rwanda"
                className="images  w-48 h-32 object-contain"
              />
            </div>
            <div className="countupf flex flex-cols-2 space-x-4">
              <CountUp
                end={80}
                duration={10}
                className="text-5xl font-bold group-hover:scale-110 transition-transform"
              />
              <div className="font-extrabold  text-white text-3xl">+</div>
            </div>
            <p className="mt-2 py-2 text-lg group-hover:text-blue-300 transition-colors">
              Trusted Partners
            </p>
          </div>
        </div>
      </div>
      <div>
        <h2 className="text-white text-center font-semibold text-4xl p-8 countupfhd">
          We are glad to see you!
        </h2>
        <p className="text-lg leading-8 text-white">
          At GrandShop Rwanda, we’re more than just a software development
          team—we’re dedicated partners in bringing your vision to life. Our
          passion is creating innovative, custom solutions that make a real
          impact, whether you’re a startup, an established business, or an
          organization looking to grow. We believe in clear communication,
          collaborative problem-solving, and delivering results that exceed
          expectations. By combining cutting-edge technology with a deep
          understanding of your unique needs, we ensure that each project is not
          only effective but also future-ready. Join us, and let’s build
          something amazing together!
        </p>
      </div>
    </div>
  );
}

export default Numbers;
